import React from "react";
import { useMediaQuery } from "react-responsive";
import boximg from "../../assets/image/tempvideoboxforabout.png";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import { Carousel } from "react-bootstrap";
import { baseUrl } from "../../utils/base_url";

const PractitionersCarousel = ({ data }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  return (
    <>
      {data?.about_header?.cover_media &&
      data?.about_header?.cover_media?.length >= 0 ? (
        <Carousel
          pause={false}
          indicators={false}
          interval={5000}
          controls={false}
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            height: _1200
              ? "max-content"
              : _1400
              ? "70vh"
              : _1800
              ? "55vh"
              : "70vh",
          }}
        >
          {data?.about_header?.cover_media?.map((image, idx) => (
            <Carousel.Item
              key={idx}
              style={{
                // height:"55vh",
                height: "100%",
                width: "100%",
              }}
            >
              {image?.mime?.includes("video") ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <video
                    autoPlay
                    loop
                    muted
                    // width={"100%"}
                    className=""
                    style={{
                      objectFit: "cover",
                      // height: "55vh",
                      height: "100%",
                      width: "100%",
                      borderRadius: "20px",
                    }}
                  >
                    <source
                      src={`${baseUrl}${image?.url}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <img
                  className="d-block w-100"
                  style={{ objectFit: "cover", height: "55vh" }}
                  src={`${baseUrl}${image?.url}`}
                  alt="..."
                />
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <div className="d-flex align-items-center justify-content-center pb-3">
          <img src={boximg} alt="" style={{ width: "100%" }} />
        </div>
      )}
    </>
  );
};

export default PractitionersCarousel;
